import React from "react";
import AssetVisual from "./AssetVisual";

export default function PageHero({ eyebrow, title, italic, sub, tone = ["#0B0B0C", "#1b1d24"] }) {
  return (
    <section className="dark" style={{ position: "relative", overflow: "hidden", paddingTop: "clamp(72px,10vw,128px)", paddingBottom: "clamp(56px,8vw,104px)" }}>
      <div style={{ position: "absolute", inset: 0, opacity: 0.4 }}><AssetVisual tone={tone} accent="#D4AF37" /></div>
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(90deg, var(--obsidian) 40%, rgba(11,11,12,0.5))" }} />
      <div className="shell" style={{ position: "relative" }}>
        <span className="eyebrow on-dark reveal">{eyebrow}</span>
        <h1 className="display reveal" style={{ marginTop: 22, maxWidth: "18ch", fontSize: "clamp(2.4rem,6vw,5rem)" }}>
          {title} {italic && <span className="serif-italic gold-text">{italic}</span>}
        </h1>
        {sub && <p className="lead reveal" style={{ marginTop: 24, maxWidth: 580 }}>{sub}</p>}
      </div>
    </section>
  );
}
